// Restaurant dish photos for gallery
export const galleryImages = [
  {
    src: '/images/lobster_thermidor.jpg',
    alt: 'Lobster Thermidor - Signature dish with rich cream sauce',
    category: 'Mariscos'
  },
  {
    src: '/images/lobster_salad_platter.jpg',
    alt: 'Lobster Salad Platter - Fresh lobster with seasonal vegetables',
    category: 'Entradas'
  },
  {
    src: '/images/steak_with_vegetables.jpg',
    alt: 'Steak with Seasonal Vegetables - Prime cut with gourmet presentation',
    category: 'Carnes'
  },
  {
    src: '/images/snails_garlic_herbs.jpg',
    alt: 'Escargot in Garlic and Herbs - Classic French preparation',
    category: 'Entradas'
  },
  {
    src: '/images/gourmet_dessert_cakes.jpg',
    alt: 'Gourmet Dessert Selection - Artisanal sweet creations',
    category: 'Postres'
  },
  {
    src: '/images/strawberry_cream_cake.jpg',
    alt: 'Strawberry Cream Cake - Fresh seasonal berries with cream',
    category: 'Postres'
  },
  {
    src: '/images/tiramisu_dessert_plating.jpg',
    alt: 'Tiramisu - Traditional Italian dessert with modern presentation',
    category: 'Postres'
  },
  {
    src: '/images/dessert_fruit_tart_plating.jpg',
    alt: 'Fruit Tart - Elegant dessert with artistic plating',
    category: 'Postres'
  },
  {
    src: '/images/seafood_platter_1.jpg',
    alt: 'Seafood Platter - Fresh selection from the Mediterranean',
    category: 'Mariscos'
  },
  {
    src: '/images/appetizer_course_1.jpg',
    alt: 'Gourmet Appetizer - Chef\'s signature starter',
    category: 'Entradas'
  },
  {
    src: '/images/fine_dining_presentation.jpg',
    alt: 'Fine Dining Presentation - Artisanal culinary art',
    category: 'Especialidades'
  },
  {
    src: '/images/romantic_table_setting.jpg',
    alt: 'Romantic Table Setting - Perfect ambiance for special occasions',
    category: 'Ambiente'
  }
];